import { useQuery } from '@tanstack/react-query'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { useApi } from '@fortem-monorepo/react-spa'
import { Swapagg } from '@fortem-monorepo/web-sdk'

export const useMissingExternalMappings = (
  params: Swapagg.GetMissingExternalMappingsParams = { value_date: toISO8601(new Date()) },
) => {
  const api = useApi()

  return useQuery({
    queryKey: ['mappings/missing-external-mappings', params],
    queryFn: () => {
      return api.swapagg.getMissingExternalMappings(params)
    },
  })
}
